export default "__VITE_ASSET__BAnxRT5o__"